/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { Tabs, TabPanel, Nav } from '@restart/ui';
import Tab from '../../shared/Tab';

const TabBar = ({
  defaultActiveKey = "1",
  dividerClassName = 'mt-16',
  tabs = []
}) => {
  const [tabsLength, setTabsLength] = useState(1);
  const [tabsHeader, setTabsHeader] = useState([]);
  const [tabsPanel, setTabsPanel] = useState([]);

  useEffect(() => {
    const newHeader = [];
    const newPanel = [];
    tabs.forEach((tab) => {
      if (!tab.disabled) {
        const { header, panel, tooltip, panelProps } = tab;
        newHeader.push({ header, tooltip });
        newPanel.push({ panel, panelProps });
      }
    });
    setTabsHeader(newHeader);
    setTabsPanel(newPanel);
    setTabsLength(newPanel.length);
  }, [tabs]);

  return (
    <Tabs defaultActiveKey={defaultActiveKey}>
      <div className="chat-details-tabs">
        <Nav className="p-relative" style={{ '--tabs-number': tabsLength }}>
          {tabsHeader.map((tab, tabIdx) => (
            <Tab eventKey={String(tabIdx + 1)} tooltip={tab.tooltip} key={`tab-header-${tabIdx}`}>
              {tab.header}
            </Tab>
          ))}
          <div className="figma-tab-inkbar"></div>
        </Nav>
        <div className={`divider-line p-relative ${dividerClassName}`}></div>
        <div className="p-6 chat-details-tab-body">
          {tabsPanel.map((tab, tabIdx) => (
            <TabPanel eventKey={String(tabIdx + 1)} {...tab.panelProps} key={`tab-panel-${tabIdx}`}>
              {tab.panel}
            </TabPanel>
          ))}
        </div>
      </div>
    </Tabs>
  );
};

export default TabBar;
